// extracted by mini-css-extract-plugin
module.exports = {"pieButton":"PieButton_pieButton__32HzX","value":"PieButton_value__9HAQv","value2":"PieButton_value2__3M5vu","background":"PieButton_background__1kwBF"};